﻿import React, { useState, useEffect } from 'react';
//Components
import { MenuItem, Checkbox, Select, FormControlLabel, Input, CircularProgress } from '@mui/material';
import LoadingIndicator from 'components/Global/loading-indicator/loading-indicator';
//Utilities
import {
  GetProductListAll,
  GetAgeList,
  GetMiscellaneousForms
} from 'api/apppackage';
import { GetResponses, GetSourceOfFunds, GetAnnuities, GetStates } from 'api/referencedata';
import useForm from '../../../../AdminContentMgt/Components/useForm';
import { useQuery } from '@tanstack/react-query';
import { useUser } from 'context/UserContext';

export default function AppPackageProducts({ setAppPackageValues }) {
  const user = useUser();
  const urlParams = new URLSearchParams(window.location.search);
  const [form, setForm] = useState(null);
  const [currentProduct, setCurrentProduct] = useState(urlParams.get('productid'));
  const [productName, setProductName] = useState('');
  const [disabledFormValues, setDisabledFormValues] = useState(null); //used for disabling form values
  const [division, setDivision] = useState(
    user.isHO == true && urlParams.get('overrideDivision') != undefined
      ? urlParams.get('overrideDivision')
      : user.division
  );

  var IQumulateProductID = '17';
  var GenLegProductID = '9';
  var WholeLifeProductID = '2';

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    setErrors({
      ...temp,
    });

    if (fieldValues == values) return Object.values(temp).every((x) => x == '');
  };

  const { values, errors, setErrors, setValues, handleDataChange } = useForm(form, true, validate);

  const [showChildRiders, setShowChildRiders] = useState(false);

  const [existingDisplay, setExistingDisplay] = useState(null);
  const [replacementDisplay, setReplacementDisplay] = useState(null);
  const [lapseSurrenderDisplay, setLapseSurrenderDisplay] = useState(null);
  const [exchangeDisplay, setExchangeDisplay] = useState(null);
  const getAnnuityQuery = useQuery({
    queryKey: ['GetAnnuities', productName],
    queryFn: () => GetAnnuities(productName)(),
    enabled: productName !== '',
  });
  const getStateQuery = useQuery({
    queryKey: ['GetStates'],
    queryFn: () => GetStates()(),
  });
  const exchangeOptions = [
    { text: 'Non-Qualified Transfer', value: 'NA' },
    { text: '1035 Exchange', value: 'Yes' },
    { text: 'N/A', value: 'NA' },
  ];
  const getFundingSourceQuery = useQuery({
    queryKey: ['GetSourceOfFunds'],
    queryFn: () => GetSourceOfFunds()(),
  });
  const getYesNoQuery = useQuery({
    queryKey: ['GetResponses'],
    queryFn: () => GetResponses()(),
  });
  const getAgeList = useQuery({
    queryKey: ['GetAgeList'],
    queryFn: () => GetAgeList()(),
  });
  const productListQuery = useQuery({
    queryKey: ['GetProductListAll'],
    queryFn: () => GetProductListAll()(),
  });
  const getServiceFormsQuery = useQuery({
    queryKey: [
      'GetMiscellaneousForms',
      urlParams.get('productid'),
      productName,
      values?.state ?? 'NA',
    ],
    queryFn: () =>
      GetMiscellaneousForms({
        BusinessLine: division === 'CASG' ? 'CASG' : division === 'ISD' ? 'ISD' : 'NA',
        Product: productName,
        AnnuityType: 'NA',
        State: values?.state ?? 'NA',
        FundSource: 'NA',
        Existing: 'NA',
        Replacement: 'NA',
        Exchange: 'NA',
        Rollover: 'NA',
        Transfer: 'NA',
        FullyUnderwritten: 'NA',
        SurrenderCharges: 'NA',
      })(),
    enabled:
      getYesNoQuery.data != null &&
      getAnnuityQuery.data != null &&
      getStateQuery.data != null &&
      productName !== '',
    staleTime: 5 * 60 * 1000,
  });

  //send the values back up to the parent - App Package
  useEffect(() => {
    if (values != null) {
      values.numberOfChildren = showChildRiders === true ? values.numberOfChildren : null;
      //SetSurrenderCharges();

      setAppPackageValues(values);
    }
  }, [values]);

  const BuildFormList = (serviceLst) => {
    var tmpLst = [serviceLst.length];

    for (var i = 0; i < serviceLst.length; i++) {
      tmpLst[i] = serviceLst[i];

      //preselect 1483 form if career
      if (tmpLst[i].formNumber == '7' && division == 'CASG') tmpLst[i].selected = true;
      else tmpLst[i].selected = false;
    }

    return tmpLst;
  };

  const GetProductFormByID = (data) => {
    //ref the data
    let yesNoDontDefaultValue = getYesNoQuery.data[0].value;
    //fully underwritten is yes by default, otherwise it's no
    let yesNoDefaultValue = getYesNoQuery.data[0].value;
    //set to Delaware by default if career, otherwise set to Alabama for isd
    let defaultStateName = division === 'CASG' ? 'Delaware' : 'Alabama';
    let defaultState = getStateQuery.data.find((s) => s.text === defaultStateName);
    let stateDefaultValue = defaultState.code;
    let stateIDDefaultValue = defaultState.id;
    let annuityDefaultValue = getAnnuityQuery.data[0].value;
    let exchange1035DefaultValue = exchangeOptions[0].value;
    //set funding source to non-qualified annuity if generation legacy by default, otherwise set to annuity
    let fundingDefaultValue =
      currentProduct == GenLegProductID
        ? getFundingSourceQuery.data[2].value
        : getFundingSourceQuery.data[0].value;
    let ageDefaultValue = getAgeList.data.listValues[0].value;
    //fullyUnderWritten dropdown options come from getYesNoQuery, whose "No" value is 'NA' rather than the literal text 'No'
    let fullyUnderWrittenYesValue = getYesNoQuery.data.find((r) => r.text === 'Yes')?.value ?? 'Yes';
    let fullyUnderWrittenNoValue = getYesNoQuery.data.find((r) => r.text === 'No')?.value ?? 'No';
    var fullyUnderWrittenVal =
      urlParams.get('fullyunderwritten') != undefined
        ? urlParams.get('fullyunderwritten') == 'true'
          ? fullyUnderWrittenYesValue
          : fullyUnderWrittenNoValue
        : fullyUnderWrittenYesValue;
    var tmpLst = BuildFormList(data);

    switch (currentProduct) {
      //iQumulate
      case IQumulateProductID:
        return {
          appId: 0,
          product: currentProduct,
          annuityType: annuityDefaultValue,
          state: stateDefaultValue,
          fundSource: null,
          existing: yesNoDontDefaultValue,
          replacement: yesNoDontDefaultValue,
          lapseSurrender: null,
          exchange: exchange1035DefaultValue,
          inSpeed: null,
          rollover: yesNoDefaultValue,
          transfer: yesNoDefaultValue,
          fullyUnderWritten: fullyUnderWrittenNoValue,
          age: null,
          numberOfChildren: null,
          formList: tmpLst,
          surrenderCharges: null,
          eft: yesNoDefaultValue,
          replacementq1: yesNoDefaultValue,
          replacementq2: yesNoDefaultValue,
          replacementq3: yesNoDefaultValue,
          stateID: stateIDDefaultValue,
          qualified: yesNoDefaultValue,
        };
      //single premium immediate annuity, Choice SPDA 5 Year / 7 Year, Flexiable Premium Deferred Annuity
      case '13':
      case '11':
      case '12':
      case '10':
        return {
          appId: 0,
          product: currentProduct,
          annuityType: annuityDefaultValue,
          state: stateDefaultValue,
          fundSource: null,
          existing: yesNoDontDefaultValue,
          replacement: yesNoDontDefaultValue,
          lapseSurrender: yesNoDontDefaultValue,
          exchange: yesNoDefaultValue,
          inSpeed: null,
          rollover: yesNoDefaultValue,
          transfer: yesNoDefaultValue,
          fullyUnderWritten: fullyUnderWrittenVal,
          age: null,
          numberOfChildren: null,
          formList: tmpLst,
          surrenderCharges: null,
          eft: null,
          replacementq1: null,
          replacementq2: null,
          replacementq3: null,
          stateID: stateIDDefaultValue,
          qualified: null,
        };
      //Internal Annuity or Other Internal Funds
      case '14':
        return {
          appId: 0,
          product: currentProduct,
          annuityType: annuityDefaultValue,
          state: stateDefaultValue,
          fundSource: null,
          existing: yesNoDontDefaultValue,
          replacement: yesNoDontDefaultValue,
          lapseSurrender: yesNoDontDefaultValue,
          exchange: yesNoDefaultValue,
          inSpeed: null,
          rollover: yesNoDefaultValue,
          transfer: yesNoDefaultValue,
          fullyUnderWritten: fullyUnderWrittenVal,
          age: null,
          numberOfChildren: null,
          formList: tmpLst,
          surrenderCharges: null,
          eft: null,
          replacementq1: null,
          replacementq2: null,
          replacementq3: null,
          stateID: stateIDDefaultValue,
          qualified: null,
        };
      //Generation Legacy
      case GenLegProductID:
        return {
          appId: 0,
          product: currentProduct,
          annuityType: annuityDefaultValue,
          state: stateDefaultValue,
          fundSource: null,
          existing: yesNoDontDefaultValue,
          replacement: yesNoDontDefaultValue,
          lapseSurrender: yesNoDontDefaultValue,
          exchange: yesNoDefaultValue,
          inSpeed: null,
          rollover: yesNoDefaultValue,
          transfer: yesNoDefaultValue,
          fullyUnderWritten: fullyUnderWrittenVal,
          age: null,
          numberOfChildren: null,
          formList: tmpLst,
          surrenderCharges: null,
          eft: null,
          replacementq1: null,
          replacementq2: null,
          replacementq3: null,
          stateID: stateIDDefaultValue,
          qualified: null,
        };
      //Critical Illness, Whole Life
      case '6':
        return {
          appId: 0,
          product: currentProduct,
          annuityType: null,
          state: stateDefaultValue,
          fundSource: null,
          existing: yesNoDontDefaultValue,
          replacement: yesNoDontDefaultValue,
          lapseSurrender: yesNoDontDefaultValue,
          exchange: yesNoDefaultValue,
          inSpeed: null,
          rollover: null,
          transfer: yesNoDefaultValue,
          fullyUnderWritten: fullyUnderWrittenVal,
          age: ageDefaultValue,
          numberOfChildren: null,
          formList: tmpLst,
          surrenderCharges: null,
          eft: null,
          replacementq1: null,
          replacementq2: null,
          replacementq3: null,
          stateID: stateIDDefaultValue,
          qualified: null,
        };
      //Universal Life
      case '8':
        return {
          appId: 0,
          product: currentProduct,
          annuityType: null,
          state: stateDefaultValue,
          fundSource: null,
          existing: yesNoDontDefaultValue,
          replacement: yesNoDontDefaultValue,
          lapseSurrender: yesNoDontDefaultValue,
          exchange: yesNoDefaultValue,
          inSpeed: null,
          rollover: null,
          transfer: yesNoDefaultValue,
          fullyUnderWritten: fullyUnderWrittenNoValue,
          age: ageDefaultValue,
          numberOfChildren: null,
          formList: tmpLst,
          surrenderCharges: null,
          eft: null,
          replacementq1: null,
          replacementq2: null,
          replacementq3: null,
          stateID: stateIDDefaultValue,
          qualified: null,
        };
      //Whole Life
      case WholeLifeProductID:
        return division == 'CASG'
          ? {
              appId: 0,
              product: currentProduct,
              annuityType: null,
              state: stateDefaultValue,
              fundSource: null,
              existing: yesNoDontDefaultValue,
              replacement: yesNoDontDefaultValue,
              lapseSurrender: yesNoDontDefaultValue,
              exchange: yesNoDefaultValue,
              inSpeed: null,
              rollover: null,
              transfer: yesNoDefaultValue,
              fullyUnderWritten: fullyUnderWrittenNoValue,
              age: ageDefaultValue,
              numberOfChildren: null,
              formList: tmpLst,
              surrenderCharges: null,
              eft: null,
              replacementq1: null,
              replacementq2: null,
              replacementq3: null,
              stateID: stateIDDefaultValue,
              qualified: null,
            }
          : {
              appId: 0,
              product: currentProduct,
              annuityType: null,
              state: stateDefaultValue,
              fundSource: null,
              existing: yesNoDontDefaultValue,
              replacement: yesNoDontDefaultValue,
              lapseSurrender: yesNoDontDefaultValue,
              exchange: yesNoDefaultValue,
              inSpeed: null,
              rollover: null,
              transfer: yesNoDefaultValue,
              fullyUnderWritten: fullyUnderWrittenNoValue,
              age: ageDefaultValue,
              numberOfChildren: null,
              formList: tmpLst,
              surrenderCharges: null,
              eft: null,
              replacementq1: null,
              replacementq2: null,
              replacementq3: null,
              stateID: stateIDDefaultValue,
              qualified: null,
            };
      //Term
      case '1':
        return division == 'CASG'
          ? {
              appId: 0,
              product: currentProduct,
              annuityType: null,
              state: stateDefaultValue,
              fundSource: null,
              existing: yesNoDontDefaultValue,
              replacement: yesNoDontDefaultValue,
              lapseSurrender: yesNoDontDefaultValue,
              exchange: yesNoDefaultValue,
              inSpeed: null,
              rollover: null,
              transfer: yesNoDefaultValue,
              fullyUnderWritten: fullyUnderWrittenVal,
              age: ageDefaultValue,
              numberOfChildren: null,
              formList: tmpLst,
              surrenderCharges: null,
              eft: null,
              replacementq1: null,
              replacementq2: null,
              replacementq3: null,
              stateID: stateIDDefaultValue,
              qualified: null,
            }
          : {
              appId: 0,
              product: currentProduct,
              annuityType: null,
              state: stateDefaultValue,
              fundSource: null,
              existing: yesNoDontDefaultValue,
              replacement: yesNoDontDefaultValue,
              lapseSurrender: yesNoDontDefaultValue,
              exchange: yesNoDefaultValue,
              inSpeed: null,
              rollover: null,
              transfer: yesNoDefaultValue,
              fullyUnderWritten: fullyUnderWrittenVal,
              age: ageDefaultValue,
              numberOfChildren: null,
              formList: tmpLst,
              surrenderCharges: null,
              eft: null,
              replacementq1: null,
              replacementq2: null,
              replacementq3: null,
              stateID: stateIDDefaultValue,
              qualified: null,
            };
      //Sing. Prem. Whole Life
      case '7':
        return division == 'ISD'
          ? {
              appId: 0,
              product: currentProduct,
              annuityType: null,
              state: stateDefaultValue,
              fundSource: null,
              existing: yesNoDontDefaultValue,
              replacement: yesNoDontDefaultValue,
              lapseSurrender: yesNoDontDefaultValue,
              exchange: yesNoDefaultValue,
              inSpeed: null,
              rollover: null,
              transfer: yesNoDefaultValue,
              fullyUnderWritten: fullyUnderWrittenVal,
              age: getAgeList.data.listValues[getAgeList.data.listValues.length - 1].value,
              numberOfChildren: null,
              formList: tmpLst,
              surrenderCharges: null,
              eft: null,
              replacementq1: null,
              replacementq2: null,
              replacementq3: null,
              stateID: stateIDDefaultValue,
              qualified: null,
            }
          : {
              appId: 0,
              product: currentProduct,
              annuityType: null,
              state: stateDefaultValue,
              fundSource: fundingDefaultValue,
              existing: yesNoDontDefaultValue,
              replacement: yesNoDontDefaultValue,
              lapseSurrender: yesNoDontDefaultValue,
              exchange: yesNoDefaultValue,
              inSpeed: null,
              rollover: null,
              transfer: yesNoDefaultValue,
              fullyUnderWritten: fullyUnderWrittenVal,
              age: getAgeList.data.listValues[getAgeList.data.listValues.length - 1].value,
              numberOfChildren: null,
              formList: tmpLst,
              surrenderCharges: null,
              eft: null,
              replacementq1: null,
              replacementq2: null,
              replacementq3: null,
              stateID: stateIDDefaultValue,
              qualified: null,
            };
      //Silver Guard
      case '4':
        return division == 'CASG'
          ? {
              appId: 0,
              product: currentProduct,
              annuityType: null,
              state: stateDefaultValue,
              fundSource: null,
              existing: yesNoDontDefaultValue,
              replacement: yesNoDontDefaultValue,
              lapseSurrender: yesNoDontDefaultValue,
              exchange: yesNoDefaultValue,
              inSpeed: null,
              rollover: null,
              transfer: yesNoDefaultValue,
              fullyUnderWritten: fullyUnderWrittenVal,
              age: null,
              numberOfChildren: null,
              formList: tmpLst,
              surrenderCharges: null,
              eft: yesNoDefaultValue,
              replacementq1: null,
              replacementq2: null,
              replacementq3: null,
              stateID: stateIDDefaultValue,
              qualified: null,
            }
          : {
              appId: 0,
              product: currentProduct,
              annuityType: null,
              state: stateDefaultValue,
              fundSource: null,
              existing: yesNoDontDefaultValue,
              replacement: yesNoDontDefaultValue,
              lapseSurrender: yesNoDontDefaultValue,
              exchange: yesNoDefaultValue,
              inSpeed: null,
              rollover: null,
              transfer: yesNoDefaultValue,
              fullyUnderWritten: fullyUnderWrittenVal,
              age: null,
              numberOfChildren: null,
              formList: tmpLst,
              surrenderCharges: null,
              eft: yesNoDefaultValue,
              replacementq1: null,
              replacementq2: null,
              replacementq3: null,
              stateID: stateIDDefaultValue,
              qualified: null,
            };
      //iProvide
      case '15':
        return division == 'CASG'
          ? {
              appId: 0,
              product: currentProduct,
              annuityType: null,
              state: stateDefaultValue,
              fundSource: null,
              existing: yesNoDontDefaultValue,
              replacement: yesNoDontDefaultValue,
              lapseSurrender: yesNoDontDefaultValue,
              exchange: yesNoDefaultValue,
              inSpeed: null,
              rollover: null,
              transfer: yesNoDefaultValue,
              fullyUnderWritten: fullyUnderWrittenNoValue,
              age: null,
              numberOfChildren: null,
              formList: tmpLst,
              surrenderCharges: null,
              eft: null,
              replacementq1: null,
              replacementq2: null,
              replacementq3: null,
              stateID: stateIDDefaultValue,
              qualified: null,
            }
          : {
              appId: 0,
              product: currentProduct,
              annuityType: null,
              state: stateDefaultValue,
              fundSource: null,
              existing: yesNoDontDefaultValue,
              replacement: yesNoDontDefaultValue,
              lapseSurrender: yesNoDontDefaultValue,
              exchange: yesNoDefaultValue,
              inSpeed: null,
              rollover: null,
              transfer: yesNoDefaultValue,
              fullyUnderWritten: fullyUnderWrittenNoValue,
              age: null,
              numberOfChildren: null,
              formList: tmpLst,
              surrenderCharges: null,
              eft: null,
              replacementq1: null,
              replacementq2: null,
              replacementq3: null,
              stateID: stateIDDefaultValue,
              qualified: null,
            };
      case '16':
        return division == 'CASG'
          ? {
              appId: 0,
              product: currentProduct,
              annuityType: null,
              state: stateDefaultValue,
              fundSource: '2',
              existing: yesNoDontDefaultValue,
              replacement: yesNoDontDefaultValue,
              lapseSurrender: yesNoDontDefaultValue,
              exchange: yesNoDefaultValue,
              inSpeed: null,
              rollover: null,
              transfer: yesNoDefaultValue,
              fullyUnderWritten: fullyUnderWrittenNoValue,
              age: null,
              numberOfChildren: null,
              formList: tmpLst,
              surrenderCharges: null,
              eft: null,
              replacementq1: null,
              replacementq2: null,
              replacementq3: null,
              stateID: stateIDDefaultValue,
              qualified: null,
            }
          : {
              appId: 0,
              product: currentProduct,
              annuityType: null,
              state: stateDefaultValue,
              fundSource: '2',
              existing: yesNoDontDefaultValue,
              replacement: yesNoDontDefaultValue,
              lapseSurrender: yesNoDontDefaultValue,
              exchange: yesNoDefaultValue,
              inSpeed: null,
              rollover: null,
              transfer: yesNoDefaultValue,
              fullyUnderWritten: fullyUnderWrittenNoValue,
              age: null,
              numberOfChildren: null,
              formList: tmpLst,
              surrenderCharges: null,
              eft: null,
              replacementq1: null,
              replacementq2: null,
              replacementq3: null,
              stateID: stateIDDefaultValue,
              qualified: null,
            };
      default:
        break;
    }
  };

  //handles whether or not form values are disabled - true for disabled
  const HandleDisabledFormValues = () => {
    var underwritten = false;
    var inspeed = false;
    var exchange = false;
    var age = false;
    var fundSource = false;

    if (currentProduct == '16') fundSource = true;

    //Generation Legacy or Single Prem Whole Life or Silver Guard
    //Or we are Career and single premium immediate annuity, Choice SPDA 5 Year / 7 Year, Flexiable Premium Deferred Annuity, Internal Annuity or Other Internal Funds
    //Silver guard, single prem whole life
    //disable fully underwritten if using iProvide
    if (
      currentProduct == IQumulateProductID ||
      currentProduct == '15' ||
      currentProduct == '16' ||
      currentProduct == GenLegProductID ||
      currentProduct == '7' ||
      currentProduct == '4' ||
      (division == 'CASG' &&
        (currentProduct == '13' ||
          currentProduct == '11' ||
          currentProduct == '12' ||
          currentProduct == '10' ||
          currentProduct == '14' ||
          currentProduct == IQumulateProductID))
    )
      underwritten = true; //disable fully underwritten

    if (
      currentProduct == '15' ||
      currentProduct == '16' ||
      (division == 'ISD' &&
        (currentProduct == WholeLifeProductID || currentProduct == '1' || currentProduct == '7'))
    ) {
      inspeed = true;
    }

    if (division == 'ISD' && (currentProduct == '1' || currentProduct == '4')) {
      exchange = true;
    }

    //hide age for iProvide
    if (
      currentProduct == '4' ||
      currentProduct == '15' ||
      currentProduct == '16'
    )
      age = true;

    setDisabledFormValues({
      fullyUnderWritten: underwritten,
      inSpeed: inspeed,
      exchange: exchange,
      age: age,
      fundSource: fundSource,
    });
  };

  useEffect(() => {
    HandleDisabledFormValues();
  }, []);

  useEffect(() => {
    if (productListQuery.isSuccess && productListQuery.data) {
      for (var i = 0; i < productListQuery.data.listValues.length; i++) {
        if (productListQuery.data.listValues[i].productID == urlParams.get('productid'))
          setProductName(productListQuery.data.listValues[i].productName);
      }
    }
  }, [productListQuery.isSuccess, productListQuery.data]);

  useEffect(() => {
    if (getServiceFormsQuery.isSuccess && getServiceFormsQuery.data) {
      if (values == null) {
        setValues(GetProductFormByID(getServiceFormsQuery.data));
      } else {
        handleDataChange('formList', BuildFormList(getServiceFormsQuery.data));
      }
    }
  }, [getServiceFormsQuery.isSuccess, getServiceFormsQuery.data]);

  useEffect(() => {
    if (getYesNoQuery.data) {
      if (values?.existing != null) {
        const match = getYesNoQuery.data.find(r => r.value === values.existing);
        if (match) setExistingDisplay(match.text);
      }
      if (values?.replacement != null) {
        const match = getYesNoQuery.data.find(r => r.value === values.replacement);
        if (match) setReplacementDisplay(match.text);
      }
      if (values?.lapseSurrender != null) {
        const match = getYesNoQuery.data.find(r => r.value === values.lapseSurrender);
        if (match) setLapseSurrenderDisplay(match.text);
      }
    }
    if (values?.exchange != null) {
      const match = exchangeOptions.find(r => r.value === values.exchange);
      if (match) setExchangeDisplay(match.text);
    }
  }, [values?.existing, values?.replacement, values?.lapseSurrender, values?.exchange, getYesNoQuery.data]);

  //lapse/surrender is only asked when existing and replacement are shown; otherwise send NA
  useEffect(() => {
    if (
      values != null &&
      (values.existing == null || values.replacement == null) &&
      values.lapseSurrender != null &&
      values.lapseSurrender !== 'NA'
    ) {
      handleDataChange('lapseSurrender', 'NA');
    }
  }, [values?.existing, values?.replacement]);

  useEffect(() => {
    if (
      currentProduct === IQumulateProductID &&
      values?.rollover != null &&
      values.rollover !== 'Yes' &&
      values?.annuityType != null &&
      values.annuityType !== 'NA'
    ) {
      handleDataChange('annuityType', 'NA');
    }
  }, [values?.rollover, currentProduct]);

  useEffect(() => {
    if (
      currentProduct === IQumulateProductID &&
      (values?.rollover == null || values.rollover === 'NA') &&
      values?.exchange != null &&
      values.exchange !== 'NA'
    ) {
      handleDataChange('exchange', 'NA');
    }
  }, [values?.rollover, currentProduct]);

  useEffect(() => {
    if (currentProduct === GenLegProductID && values?.rollover === 'Yes') {
      if (values?.exchange != null && values.exchange !== 'NA') {
        handleDataChange('exchange', 'NA');
      }
      if (values?.transfer != null && values.transfer !== 'NA') {
        handleDataChange('transfer', 'NA');
      }
    }
  }, [values?.rollover, currentProduct]);

  useEffect(() => {
    if (currentProduct !== IQumulateProductID) return;

    if (values?.replacementq1 != null && values.existing !== values.replacementq1) {
      handleDataChange('existing', values.replacementq1);
    }

    if (values?.replacementq2 != null && values?.replacementq3 != null) {
      const derivedReplacement =
        values.replacementq2 === 'Yes' || values.replacementq3 === 'Yes' ? 'Yes' : 'No';
      if (values.replacement !== derivedReplacement) {
        handleDataChange('replacement', derivedReplacement);
      }
    }
  }, [values?.replacementq1, values?.replacementq2, values?.replacementq3, currentProduct]);

  const isLoading = () => {
    if (
      getAnnuityQuery.isPending |
      getStateQuery.isPending |
      getYesNoQuery.isPending |
      getAgeList.isPending |
      productListQuery.isPending |
      getFundingSourceQuery.isPending
    )
      return true;
    else return false;
  };

  const handleChange = (event, key) => {
    handleDataChange(key, event.target.value);
  };

  const handleFormChange = (event, index) => {
    values.formList[index].selected = event.target.checked;

    handleDataChange('formList', values.formList);
  };

  const ServiceForms = () => {
    const isRefetchingForms = getServiceFormsQuery.isFetching;
    const hasFormList = values.formList != null && values.formList.length > 0;

    if (!hasFormList && isRefetchingForms) {
      return (
        <LoadingIndicator
          style={{
            justifyContent: 'flex-start',
            width: 'auto',
            height: 'auto',
            display: 'flex',
            alignItems: 'center',
            paddingTop: 0,
          }}
        />
      );
    }

    if (!hasFormList) return null;

    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {isRefetchingForms && (
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5em' }}>
            <CircularProgress size={16} style={{ marginRight: '0.5em' }} />
            <span style={{ fontSize: '0.85em', color: '#666' }}>Updating forms...</span>
          </div>
        )}
        {values.formList.map((f, index) => (
          <FormControlLabel
            key={f.formNumber + '-' + index}
            control={
              <Checkbox
                checked={f.selected}
                onChange={(e) => {
                  handleFormChange(e, index);
                }}
                name={'checked' + f.formNumber}
                color="primary"
              />
            }
            label={f.questionText}
          />
        ))}
      </div>
    );
  };

  function GetExchangeLabel() {
    switch (currentProduct) {
      case '6':
        return 'BL Critical Illness Exchange?';
      //  case IQumulateProductID:
      //    return '1035 Exchange or NQ Transfer?';
      default:
        return '1035 Exchange?';
    }
  }

  const Dropdown = ({ disabled, query, property, tmpValue, label }) => {
    return (
      <div>
        {query != null && (disabled == null || (disabled != null && disabled == false)) && (
          <div className="row" style={{ padding: '0 0 0.5em 0' }}>
            <div className="col">
              <div className="formLabel">{label}</div>
            </div>
            <div className="col">
              <Select
                labelId={property + 'demo-simple-select-label'}
                id={property + '-select'}
                style={{ width: '15em' }}
                onChange={(e) => {
                  handleChange(e, property);
                }}
                value={tmpValue ?? ''}
                disabled={disabled != null ? disabled : false}
                key={property + '-select'}
              >
                {(tmpValue == null || tmpValue === '') && (
                  <MenuItem value="" disabled>Select...</MenuItem>
                )}
                {query.map((p, index) => (
                  <MenuItem key={p.value + '-' + index} value={p.value}>
                    {p.text}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </div>
        )}
      </div>
    );
  };

  if (values == null || isLoading() == true) return <LoadingIndicator />;

  return (
    <div>
      {isLoading() == false &&
        getYesNoQuery.data != null &&
        getAnnuityQuery.data != null &&
        getStateQuery.data != null &&
        getAgeList.data != null && (
          <div style={{ padding: '1em' }}>
            <hr />
            <div style={{ color: '#0066cc', fontSize: '1.5em', fontWeight: 'bold' }}>
              {productName}
            </div>
            <hr />

            <div className="row">
              <div className="col">
                {values.rollover != null &&
                  (currentProduct === IQumulateProductID || currentProduct === GenLegProductID) && (
                  <Dropdown
                    tmpError={errors.rollover}
                    tmpValue={values.rollover}
                    query={getYesNoQuery.data?.filter(r => r.text === 'Yes' || r.text === 'No')}
                    property={'rollover'}
                    label={'Qualified Funds?'}
                  />
                )}

                <Dropdown
                  disabled={disabledFormValues.fullyUnderWritten}
                  tmpError={errors.fullyUnderWritten}
                  tmpValue={values.fullyUnderWritten}
                  query={getYesNoQuery.data?.filter(r => r.text === 'Yes' || r.text === 'No')}
                  property={'fullyUnderWritten'}
                  label={'Fully Underwritten?'}
                />

                {values.annuityType != null && currentProduct !== IQumulateProductID && (
                  <Dropdown
                    tmpError={errors.annuityType}
                    tmpValue={values.annuityType}
                    query={getAnnuityQuery.data}
                    property={'annuityType'}
                    label={'Annuity Type'}
                  />
                )}

                {currentProduct === IQumulateProductID &&
                  values.rollover != null &&
                  values.rollover === 'Yes' &&
                  values.annuityType != null && (
                    <Dropdown
                      tmpError={errors.annuityType}
                      tmpValue={values.annuityType}
                      query={getAnnuityQuery.data}
                      property={'annuityType'}
                      label={'Annuity Type'}
                    />
                  )}

                <div>
                  {getStateQuery.data != null && (
                    <div className="row" style={{ padding: '0 0 0.5em 0' }}>
                      <div className="col">
                        <div className="formLabel">{'State'}</div>
                      </div>
                      <div className="col">
                        <Select
                          labelId={'state-apppackage-products'}
                          id={'state-select-apppackage-products'}
                          style={{ width: '15em' }}
                          onChange={(e) => {
                            let result = getStateQuery.data.find(
                              (s) => s.code === e.target.value
                            );
                            setValues({
                              ...values,
                              ['state']: result.code,
                              ['stateID']: result.id,
                            });
                        
                          }}
                          value={values.state}
                          key={'state-select-apppackage-products'}
                        >
                          {getStateQuery.data.map((p, index) => (
                            <MenuItem key={p.code + '-' + index} value={p.code}>
                              {p.text}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    </div>
                  )}
                </div>

                {values.fundSource != null && (
                  <Dropdown
                    disabled={disabledFormValues.fundSource}
                    tmpError={errors.fundSource}
                    tmpValue={values.fundSource}
                    query={getFundingSourceQuery.data}
                    property={'fundSource'}
                    label={'Fund Source'}
                  />
                )}

                {currentProduct === IQumulateProductID ? (
                  <>
                    {values.existing != null && (
                      <>
                        <Dropdown
                          tmpError={errors.replacementq1}
                          tmpValue={values.replacementq1}
                          query={getYesNoQuery.data?.filter(r => r.text === 'Yes' || r.text === 'No')}
                          property={'replacementq1'}
                          label={'Do you have Existing Insurance?'}
                        />
                        <Dropdown
                          tmpError={errors.replacementq2}
                          tmpValue={values.replacementq2}
                          query={getYesNoQuery.data?.filter(r => r.text === 'Yes' || r.text === 'No')}
                          property={'replacementq2'}
                          label={
                            'Has proposed annuitant lapsed any coverages in the last 6 months?'
                          }
                        />
                        {(values.replacementq1 === 'Yes' || values.replacementq2 === 'Yes') && (
                          <Dropdown
                            tmpError={errors.replacementq3}
                            tmpValue={values.replacementq3}
                            query={getYesNoQuery.data?.filter(r => r.text === 'Yes' || r.text === 'No')}
                            property={'replacementq3'}
                            label={'Are you replacing?'}
                          />
                        )}
                      </>
                    )}{' '}
                  </>
                ) : (
                  <>
                    {values.existing != null && (
                      <div className="row" style={{ padding: '0 0 0.5em 0' }}>
                        <div className="col">
                          <div className="formLabel">
                            {currentProduct === '6'
                              ? 'Existing Critical Illness Insurance?'
                              : 'Existing Insurance or Annuity?'}
                          </div>
                        </div>
                        <div className="col">
                          <Select
                            style={{ width: '15em' }}
                            value={existingDisplay ?? ''}
                            onChange={(e) => {
                              const item = getYesNoQuery.data.find(
                                (r) => r.text === e.target.value
                              );
                              setExistingDisplay(e.target.value);
                              handleDataChange('existing', item?.value ?? e.target.value);
                            }}
                          >
                            {(existingDisplay == null || existingDisplay === '') && (
                              <MenuItem value="" disabled>Select...</MenuItem>
                            )}
                            {getYesNoQuery.data?.map((p, i) => (
                              <MenuItem key={p.text + '-' + i} value={p.text}>
                                {p.text}
                              </MenuItem>
                            ))}
                          </Select>
                        </div>
                      </div>
                    )}

                    {values.existing != null &&
                      values.replacement != null &&
                      values.lapseSurrender != null && (
                      <div className="row" style={{ padding: '0 0 0.5em 0' }}>
                        <div className="col">
                          <div className="formLabel">
                            Policies Lapsed or Surrendered in the last 6 months?
                          </div>
                        </div>
                        <div className="col">
                          <Select
                            style={{ width: '15em' }}
                            value={lapseSurrenderDisplay ?? ''}
                            onChange={(e) => {
                              const item = getYesNoQuery.data.find(
                                (r) => r.text === e.target.value
                              );
                              setLapseSurrenderDisplay(e.target.value);
                              handleDataChange('lapseSurrender', item?.value ?? e.target.value);
                            }}
                          >
                            {(lapseSurrenderDisplay == null || lapseSurrenderDisplay === '') && (
                              <MenuItem value="" disabled>Select...</MenuItem>
                            )}
                            {getYesNoQuery.data
                              ?.filter((r) => r.text === 'Yes' || r.text === 'No')
                              .map((p, i) => (
                                <MenuItem key={p.text + '-' + i} value={p.text}>
                                  {p.text}
                                </MenuItem>
                              ))}
                          </Select>
                        </div>
                      </div>
                    )}

                    {values.replacement != null && (
                      <div className="row" style={{ padding: '0 0 0.5em 0' }}>
                        <div className="col">
                          <div className="formLabel">
                            {currentProduct === '6'
                              ? 'Replacement Critical Illness Policy?'
                              : 'Replacement?'}
                          </div>
                        </div>
                        <div className="col">
                          <Select
                            style={{ width: '15em' }}
                            value={replacementDisplay ?? ''}
                            onChange={(e) => {
                              const item = getYesNoQuery.data.find(
                                (r) => r.text === e.target.value
                              );
                              setReplacementDisplay(e.target.value);
                              handleDataChange('replacement', item?.value ?? e.target.value);
                            }}
                          >
                            {(replacementDisplay == null || replacementDisplay === '') && (
                              <MenuItem value="" disabled>Select...</MenuItem>
                            )}
                            {getYesNoQuery.data?.map((p, i) => (
                              <MenuItem key={p.text + '-' + i} value={p.text}>
                                {p.text}
                              </MenuItem>
                            ))}
                          </Select>
                        </div>
                      </div>
                    )}
                  </>
                )}

                {values.exchange != null &&
                  currentProduct !== IQumulateProductID &&
                  currentProduct !== GenLegProductID && (
                  <Dropdown
                    disabled={disabledFormValues.exchange}
                    tmpError={errors.exchange}
                    tmpValue={values.exchange}
                    query={getYesNoQuery.data?.filter(r => r.text === 'Yes' || r.text === 'No')}
                    property={'exchange'}
                    label={GetExchangeLabel()}
                  />
                )}

                {values.exchange != null &&
                  currentProduct === IQumulateProductID &&
                  values.rollover != null &&
                  values.rollover === 'NA' &&
                  (disabledFormValues.exchange == null || disabledFormValues.exchange == false) && (
                    <Dropdown
                      disabled={disabledFormValues.exchange}
                      tmpError={errors.exchange}
                      tmpValue={values.exchange}
                      query={getYesNoQuery.data?.filter(r => r.text === 'Yes' || r.text === 'No')}
                      property={'exchange'}
                      label={GetExchangeLabel()}
                    />
                )}

                {values.exchange != null &&
                  currentProduct === GenLegProductID &&
                  values.rollover != null &&
                  (values.rollover === 'No' || values.rollover === 'NA') &&
                  (disabledFormValues.exchange == null || disabledFormValues.exchange == false) && (
                    <Dropdown
                      disabled={disabledFormValues.exchange}
                      tmpError={errors.exchange}
                      tmpValue={values.exchange}
                      query={getYesNoQuery.data?.filter(r => r.text === 'Yes' || r.text === 'No')}
                      property={'exchange'}
                      label={GetExchangeLabel()}
                    />
                )}

                {values.inSpeed != null && (
                  <Dropdown
                    disabled={disabledFormValues.inSpeed}
                    tmpError={errors.inSpeed}
                    tmpValue={values.inSpeed}
                    query={getYesNoQuery.data?.filter(r => r.text === 'Yes' || r.text === 'No')}
                    property={'inSpeed'}
                    label={'InSpeed App?'}
                  />
                )}

                {values.age != null &&
                  getAgeList.data.listValues != null &&
                  currentProduct !== '7' &&
                  (disabledFormValues.age == null ||
                    (disabledFormValues.age != null && disabledFormValues.age == false)) && (
                    <div>
                      <div className="row" style={{ padding: '0 0 0.5em 0' }}>
                        <div className="col">
                          <div className="formLabel">{'Age Range'}</div>
                        </div>
                        <div className="col">
                          <Select
                            labelId={'age' + 'demo-simple-select-label'}
                            id={'age' + '-select'}
                            style={{ width: '15em' }}
                            onChange={(e) => {
                              handleDataChange('age', e.target.value);
                              setShowChildRiders(e.target.value !== '1');
                            }}
                            value={values.age}
                            disabled={
                              disabledFormValues.age != null ? disabledFormValues.age : false
                            }
                            key={'age' + '-select'}
                          >
                            {getAgeList.data.listValues.map((p, index) => (
                              <MenuItem key={p.value + '-' + index} value={p.value}>
                                {p.text}
                              </MenuItem>
                            ))}
                          </Select>
                        </div>
                      </div>
                    </div>
                  )}

                {showChildRiders &&
                  (disabledFormValues.numberOfChildren == null ||
                    (disabledFormValues.numberOfChildren != null &&
                      disabledFormValues.numberOfChildren == false)) && (
                    <div>
                      <div className="row" style={{ padding: '0 0 0.5em 0' }}>
                        <div className="col">
                          <div className="formLabel">Number of Child Riders</div>
                        </div>
                        <div className="col">
                          <Input
                            labelId={'numberOfChildren' + 'demo-simple-select-label'}
                            id={'numberOfChildren' + '-select'}
                            style={{ width: '15em' }}
                            onChange={(e) => {
                              handleDataChange('numberOfChildren', e.target.value);
                            }}
                            value={
                              values.numberOfChildren == null || isNaN(values.numberOfChildren)
                                ? 0
                                : values.numberOfChildren
                            }
                            disabled={
                              disabledFormValues.numberOfChildren != null
                                ? disabledFormValues.numberOfChildren
                                : false
                            }
                            key={'numberOfChildren' + '-select'}
                          ></Input>
                        </div>
                      </div>
                    </div>
                  )}

                {values.rollover != null &&
                  currentProduct !== IQumulateProductID &&
                  currentProduct !== GenLegProductID && (
                  <Dropdown
                    tmpError={errors.rollover}
                    tmpValue={values.rollover}
                    query={getYesNoQuery.data?.filter(r => r.text === 'Yes' || r.text === 'No')}
                    property={'rollover'}
                    label={'Rollover?'}
                  />
                )}

                {values.transfer != null &&
                  (currentProduct !== GenLegProductID ||
                    values.rollover === 'No' ||
                    values.rollover === 'NA') && (
                  <Dropdown
                    tmpValue={values.transfer}
                    query={getYesNoQuery.data?.filter(r => r.text === 'Yes' || r.text === 'No')}
                    property={'transfer'}
                    label={'Requesting Funds from a Non-Insurance Entity?'}
                  />
                )}

                {values.surrenderCharges != null && (
                  <Dropdown
                    tmpValue={values.surrenderCharges}
                    query={getYesNoQuery.data?.filter(r => r.text === 'Yes' || r.text === 'No')}
                    property={'surrenderCharges'}
                    label={'Surrender Charges'}
                  />
                )}
              </div>
              <div className="col">
                <ServiceForms />
              </div>
            </div>
          </div>
        )}
    </div>
  );
}
